import { NgModule } from '@angular/core';
import { SlideItemDirective } from './slide-item/slide-item';
import {AlwaysSquareDirective} from "./always-square/always-square";
import {TabindexDirective} from "./tab-index/tabIndex.directive";
import { LongPress } from './long-press/long-press';
import { ValidateInputDirective } from './validate-input/validate-input';
import { HandleMultipleTouchDirective } from './handle-multiple-touch/handle-multiple-touch';

@NgModule({
	declarations: [SlideItemDirective, AlwaysSquareDirective, TabindexDirective,
    LongPress,
    ValidateInputDirective,
    HandleMultipleTouchDirective,
    HandleMultipleTouchDirective],
	imports: [],
	exports: [SlideItemDirective, AlwaysSquareDirective, TabindexDirective,
    LongPress,
    ValidateInputDirective,
    HandleMultipleTouchDirective,
    HandleMultipleTouchDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts